module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "node node-type-comparison"
  }, [_c('div', {
    staticClass: "article-parent-wrapper"
  }, [_c('article-header', {
    staticClass: "hidden-sm-up",
    attrs: {
      "node": _vm.node
    }
  }), _c('div', {
    staticClass: "container article-content-wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-12"
  }, [_c('author-pane', {
    attrs: {
      "node": _vm.node
    }
  }), _c('share-pane', {
    attrs: {
      "node": _vm.node
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-sm-8"
  }, [_c('comparison-product-carousel', {
    staticClass: "hidden-sm-up",
    attrs: {
      "products": _vm.products
    }
  }), _c('div', {
    staticClass: "article-body-wrapper"
  }, [_c('body-head', {
    attrs: {
      "node": _vm.node
    }
  }), _c('comparison-product-carousel', {
    staticClass: "hidden-md-down",
    attrs: {
      "products": _vm.products
    }
  }), _c('field-body', {
    ref: "articleBody",
    attrs: {
      "body": _vm.node.body,
      "node": _vm.node,
      "bodyOptions": _vm.bodyOptions
    }
  })], 1)], 1)])]), _vm._l((_vm.products), function(product, index) {
    return [(index === 0) ? _c('div', {
      staticClass: "divider w-100"
    }) : _vm._e(), _c('div', {
      staticClass: "container article-content-wrapper"
    }, [(product) ? _c('product-pane', {
      key: index,
      attrs: {
        "id": ("product-" + index),
        "product": product
      }
    }) : _vm._e()], 1), (index === 1) ? _c('div', {
      staticClass: "container newsletter-wrapper no-article-gutter-mobile hidden-md-up"
    }, [_c('div', {
      staticClass: "col-sm-8 offset-sm-4"
    }, [_c('div', {
      staticClass: "newsletter-form-wrapper"
    }, [_c('inline-newsletter-form', {
      attrs: {
        "newsletterType": _vm.getNewsLetterType,
        "theme": 'white'
      }
    })], 1)])]) : _vm._e(), ((index + 1 != _vm.products.length)) ? _c('div', {
      staticClass: "divider w-100"
    }) : _vm._e()]
  }), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-12"
  }), _c('div', {
    staticClass: "col-12 col-sm-8"
  }, [_c('div', {
    staticClass: "article-body-wrapper"
  }, [_c('div', {
    staticClass: "tags-wrapper"
  }, [_c('tag', {
    attrs: {
      "node": _vm.node
    }
  })], 1)])])])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed1cd01e","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/comparison/ComparisonBody.vue
// module id = 1793
// module chunks = 25